import React from 'react';
import { Button, Icons } from '@ohif/ui-next';
import { ExamLoadErrorState, getExamLoadErrorDetails } from './examLoadErrorUtils';

interface ExamLoadErrorProps {
  error: ExamLoadErrorState;
  onRetry: () => void;
}

export default function ExamLoadError({ error, onRetry }: ExamLoadErrorProps) {
  const { message, hint } = getExamLoadErrorDetails(error);

  return (
    <div className="bg-background absolute flex h-full w-full items-center justify-center p-4">
      <div className="flex w-full max-w-lg flex-col drop-shadow-2xl">
        <div className="bg-background text-primary flex items-center justify-center rounded-t-2xl p-6">
          <Icons.IllustrationNotFound />
        </div>
        <div className="bg-input h-px" />
        <div className="bg-muted flex flex-col items-center justify-center rounded-b-2xl p-8 text-center">
          <h1 className="text-foreground text-[22px] font-medium">
            Não foi possível abrir este exame
          </h1>
          <p className="text-muted-foreground mt-3 text-[16px] font-light leading-relaxed">
            {message}
          </p>
          {hint && <p className="text-muted-foreground mt-1 text-[14px] font-light">{hint}</p>}
          <Button
            className="mt-8 px-5 text-base"
            onClick={onRetry}
          >
            Tentar novamente
          </Button>
        </div>
      </div>
    </div>
  );
}
